import * as PIXI from "pixi.js";
import {texture} from "../core/AssetHelpers";
import {ShelfButton} from "./ShelfButton";

export class DragonButton extends ShelfButton {

    private readonly colors = [
        "orange",
        "red",
        "pink",
        "purple",
        "blue",
        "green",
        "yellow",
    ];
    private colorIndex = 0;

    constructor() {
        super();

        this.onClick.add(() => {
            this.colorIndex++;
            if (this.colorIndex >= this.colors.length) {
                this.colorIndex = 0;
            }
            this.sprite.texture = texture(`button-dragon-${this.colors[this.colorIndex]}`) || PIXI.Texture.EMPTY;
        });
    }
}
